import { connect } from 'twilio-video'

interface TwilioVideoConnectOptions {
  roomname: string
}

/**
 * Creates a connection to a Twilio Room
 * @param token - The Twilio Token needed to instantiate the Room
 * @param {Object} options - Connection options
 */
export default (token: string, { roomname }: TwilioVideoConnectOptions) => {
  return connect(token, {
    name: roomname,
    video: false,
    audio: false,
    networkQuality: true,
    preferredVideoCodecs: 'auto',
    bandwidthProfile: {
      video: {
        contentPreferencesMode: 'auto',
        clientTrackSwitchOffControl: 'auto'
      }
    },
    dominantSpeaker: true
  })
}
